

export const getActaStyles = () => `
  @page { size: A4; margin: 0; }
  body { font-family: 'Arial', sans-serif; font-size: 11pt; line-height: 1.5; color: #000; margin: 0; padding: 0; background-color: #f0f0f0; }

  .page {
    width: 210mm;
    min-height: 297mm;
    padding: 20mm;
    margin: 10mm auto;
    background: white;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    box-sizing: border-box;
    page-break-after: always;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .header-table { width: 100%; border-collapse: collapse; margin-bottom: 25px; }
  .header-table td { border: 1.5px solid #000; padding: 10px; text-align: center; vertical-align: middle; font-weight: bold; }
  .logo-cell { width: 100px; padding: 5px !important; }
  .logo-cell img { height: 65px; object-fit: contain; }
  .title-cell { font-size: 12pt; text-transform: none; }

  h1 { text-align: center; font-size: 18pt; margin: 30px 0; font-weight: bold; text-transform: uppercase; }
  .big-logo-container { text-align: center; margin: 30px 0; }
  .big-logo { width: 250px; }

  .doc-info-box { border: 1.5px solid #000; padding: 15px; margin: 25px 0; line-height: 1.4; font-size: 10pt; }
  .history-table { width: 100%; border-collapse: collapse; margin-top: 20px; text-align: center; font-size: 9pt; }
  .history-table td { border: 1.5px solid #000; padding: 8px; }
  .bg-grey { background-color: #f2f2f2; font-weight: bold; }

  .section-title { font-weight: bold; font-size: 11pt; margin-top: 25px; margin-bottom: 10px; border-bottom: 1.5px solid #000; padding-bottom: 5px; }
  
  .data-table { width: 100%; border-collapse: collapse; margin-top: 15px; font-size: 10pt; }
  .data-table th, .data-table td { border: 1.5px solid #000; padding: 10px; text-align: left; }
  .data-table th { background-color: #f2f2f2; width: 30%; }

  .assets-table { width: 100%; border-collapse: collapse; margin-top: 15px; font-size: 10pt; }
  .assets-table th, .assets-table td { border: 1.5px solid #000; padding: 8px; text-align: center; }
  .assets-table th { background-color: #f2f2f2; font-weight: bold; }

  .signature-section { margin-top: 60px; display: flex; justify-content: space-between; padding: 0 40px; }
  .signature-box { text-align: center; width: 260px; }
  .signature-line { border-top: 1.5px solid #000; margin-bottom: 5px; }
  .signature-name { font-weight: bold; font-size: 10pt; text-transform: uppercase; }
  .signature-title { font-size: 9pt; color: #333; }

  .evidence-container { margin-top: 20px; text-align: center; border: 1.5px solid #000; padding: 15px; background: #fafafa; }
  .evidence-img { max-width: 100%; max-height: 250px; object-fit: contain; border-radius: 4px; border: 1px solid #ddd; }

  .status-table { width: 100%; border-collapse: collapse; margin-top: 20px; }
  .status-table td { border: 1.5px solid #000; padding: 12px; vertical-align: top; }
  .status-label { background-color: #f2f2f2; font-weight: bold; width: 30%; font-size: 10pt; }
  .checkbox-group { display: flex; flex-direction: column; gap: 8px; }
  .checkbox-item { display: flex; align-items: center; gap: 10px; font-size: 10pt; }
  .box { width: 14px; height: 14px; border: 1.5px solid #000; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 11pt; }
  .conformity { margin-top: 30px; border: 1.5px solid #000; padding: 15px; text-align: justify; font-size: 10pt; line-height: 1.5; background: #fdfdfd; }

  @media print {
    body { background: none; }
    .page { margin: 0; box-shadow: none; border: none; }
    .no-print { display: none; }
  }

  .print-nav { position: fixed; bottom: 30px; right: 30px; display: flex; gap: 10px; z-index: 9999; }
  .btn-nav { padding: 12px 24px; border-radius: 50px; border: none; font-weight: bold; cursor: pointer; box-shadow: 0 4px 15px rgba(0,0,0,0.2); }
  .btn-print { background: #20c997; color: white; }
  .btn-close { background: #6c757d; color: white; }
`;

export const getActaHeader = (pageNum, totalPages, logoUrl) => `
  <table class="header-table">
    <tr>
      <td rowspan="2" class="logo-cell"><img src="${logoUrl}" alt="Logo"></td>
      <td class="title-cell" colspan="3">Unidad de Desarrollo Tecnológico y Transformación Digital</td>
    </tr>
    <tr>
      <td style="width: 30%;">Versión: 1.0.0</td>
      <td style="width: 40%;">Fecha: ${new Date().toLocaleDateString('es-CL')}</td>
      <td style="width: 30%;">Página ${pageNum} de ${totalPages}</td>
    </tr>
  </table>
`;

export const generateActaHTML = (config) => {
  const {
    type,
    currentEquipo,
    correlativo,
    docNombre,
    docRut,
    docCargo,
    dateStr,
    extraData,
    logoUrl,
    referenciaActa,
    funcionarioData,
    declarationExtra,
    mainTitle,
    typeCode,
    objectiveText,
    isInforme,
    encargadoNombre
  } = config;

  const headerHtml = (p, t) => getActaHeader(p, t, logoUrl);
  const styles = getActaStyles();

  return `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <title>${mainTitle} - ${currentEquipo.codigo}</title>
      <style>${styles}</style>
    </head>
    <body>
      <div class="print-nav no-print">
        <button class="btn-nav btn-close" onclick="window.close()">Cerrar Vista</button>
        <button class="btn-nav btn-print" onclick="window.print()">Imprimir Documento</button>
      </div>

      ${isInforme ? `
        <!-- INFORME DE UNA PÁGINA -->
        <div class="page">
          ${headerHtml(1, 1)}
          <h1 style="margin: 20px 0 10px 0;">
            ${extraData?.mantenimientoTipo === 'Dado de baja' ? 'ACTA DE BAJA DEFINITIVA Y DESINCORPORACIÓN' : mainTitle}
          </h1>
          <div style="text-align: right; font-weight: bold; margin-bottom: 20px; font-size: 10pt;">
            CORRELATIVO: ${correlativo}<br>
            FECHA: ${dateStr}<br>
            REF: ${referenciaActa}
          </div>

          <div class="section-title">DATOS DEL ACTIVO</div>
          <table class="assets-table">
            <tr class="bg-grey">
              <th style="width: 20%;">N° Inventario</th>
              <th style="width: 40%;">Modelo</th>
              <th style="width: 20%;">Categoría</th>
              <th style="width: 20%;">Estado Reportado</th>
            </tr>
            <tr>
              <td>${currentEquipo.codigo}</td>
              <td>${currentEquipo.modelo}</td>
              <td>${currentEquipo.categoria}</td>
              <td><strong style="color: #c00;">${(extraData?.mantenimientoTipo === 'Dado de baja' ? 'DADO DE BAJA' : currentEquipo.estado).toUpperCase()}</strong></td>
            </tr>
          </table>

          <div class="section-title">RELATO Y DIAGNÓSTICO DE LA SITUACIÓN</div>
          <div style="padding: 15px; border: 1.5px solid #000; min-height: 80px; text-align: justify; background: #fff; font-size: 10pt; line-height: 1.6;">
            ${extraData?.mantenimientoTipo ? `<strong>DETERMINACIÓN TÉCNICA:</strong> ${extraData.mantenimientoTipo}<br><br>` : ''}
            <strong>MOTIVO DE LA SITUACIÓN:</strong><br>
            ${extraData?.mantenimientoNotas || 'No se registraron observaciones adicionales.'}
          </div>

          ${extraData?.evidencia ? `
            <div class="section-title">EVIDENCIA FOTOGRÁFICA</div>
            <div class="evidence-container">
              <img src="${extraData.evidencia}" class="evidence-img" alt="Evidencia del Bien">
              <div style="font-size: 8pt; color: #666; margin-top: 5px;">Captura de evidencia física al momento de la gestión técnica/administrativa.</div>
            </div>
          ` : ''}




          <div class="signature-section" style="margin-top: auto; padding-bottom: 40px;">
            <div class="signature-box" style="position: relative;">
              ${extraData?.signatureEncargado ? `<img src="${extraData.signatureEncargado}" style="position: absolute; bottom: 35px; left: 50%; transform: translateX(-50%); height: 80px;">` : ''}
              <div class="signature-line" style="margin-top: 30px;"></div>
              <div class="signature-name" style="color: transparent;">.</div>
              <div class="signature-title">${encargadoNombre}</div>
            </div>
            ${type !== 'ingreso_bodega' ? `
              <div class="signature-box" style="position: relative;">
                ${extraData?.signatureCustodio ? `<img src="${extraData.signatureCustodio}" style="position: absolute; bottom: 35px; left: 50%; transform: translateX(-50%); height: 80px;">` : ''}
                <div class="signature-line" style="margin-top: 30px;"></div>
                <div class="signature-name">${extraData?.mantenimientoTipo === 'Dado de baja' ? 'EQUIPO T.D.' : docNombre.toUpperCase()}</div>
                <div class="signature-title">${extraData?.mantenimientoTipo === 'Dado de baja' ? 'Validación Técnica' : (funcionarioData ? funcionarioData.cargo : 'Funcionario Responsable')}</div>
              </div>
            ` : ''}
          </div>
        </div>
      ` : `
        <!-- ACTA ESTÁNDAR - 4 PÁGINAS -->
        <!-- PÁGINA 1: Portada + Objetivo -->
        <div class="page">
          ${headerHtml(1, 4)}
          <h1>${mainTitle}</h1>
          <div class="big-logo-container">
            <img src="${logoUrl}" class="big-logo" alt="Escudo Municipal">
          </div>
          <div class="doc-info-box">
            <strong>${typeCode}:</strong><br>
            Documento que evidencia el acto de entrega de un activo y la recepción conforme por parte del funcionario custodio municipal.
          </div>

          <div class="section-title" style="margin-top: 30px;">OBJETIVO</div>
          <p class="objective-text">El presente documento tiene como objetivo ${objectiveText}</p>
        </div>

        <!-- PÁGINA 2: Datos del Acta -->
        <div class="page">
          ${headerHtml(2, 4)}
          <h2 style="text-align: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 40px;">${mainTitle}</h2>
          <div style="margin-bottom: 50px; text-align: right; line-height: 2.2; font-weight: bold;">
            Nro: ${correlativo}<br>
            Fecha de Recepción: ${dateStr}<br>
            ${type === 'prestamo' && currentEquipo.fecha_devolucion ? `FECHA DE DEVOLUCIÓN: ${new Date(currentEquipo.fecha_devolucion + 'T12:00:00').toLocaleDateString('es-CL')}<br>` : ''}
            Ref: ${referenciaActa}
          </div>
          <table class="data-table">
            <tr class="bg-grey"><td colspan="2">${type === 'devolucion' ? 'RECEPCIÓN (BODEGA MUNICIPAL):' : 'ENTREGA:'}</td></tr>
            <tr><td>Municipalidad de Pitrufquén</td><td>${encargadoNombre} - Encargado/a de Inventario</td></tr>
            <tr class="bg-grey"><td colspan="2">${type === 'devolucion' ? 'FUNCIONARIO QUE RESTITUYE EL BIEN:' : 'RECIBE:'}</td></tr>
            <tr><td><strong>Nombre</strong></td><td>${docNombre}</td></tr>
            <tr><td><strong>Rut</strong></td><td>${docRut}</td></tr>
            <tr><td><strong>Cargo</strong></td><td>${docCargo}</td></tr>
          </table>
        </div>

        <!-- PÁGINA 3: Activos -->
        <div class="page">
          ${headerHtml(3, 4)}
          <div class="section-title">ACTIVOS</div>
          <table class="assets-table">
            <thead>
              <tr class="bg-grey">
                <th style="width: 20%;">N° Inventario</th>
                <th style="width: 35%;">ACTIVO</th>
                <th style="width: 10%;">CANT</th>
                <th style="width: 15%;">ESTADO</th>
                <th style="width: 20%;">OBSERVACIONES</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>${currentEquipo.codigo}</td>
                <td style="text-align: left;">${currentEquipo.categoria} / ${currentEquipo.modelo}</td>
                <td>1</td>
                <td>${currentEquipo.estado}</td>
                <td>${currentEquipo.detalle || ''}</td>
              </tr>
              ${Array(14).fill('<tr><td></td><td></td><td></td><td></td><td></td></tr>').join('')}
            </tbody>
          </table>
        </div>

        <!-- PÁGINA 4: Estado, Conformidad y Firmas -->
        <div class="page">
          ${headerHtml(4, 4)}
          <table class="status-table">
            <tr>
              <td class="status-label">ESTADO GENERAL</td>
              <td>
                <div class="checkbox-group">
                  <div class="checkbox-item"><div class="box">${extraData?.estadoGeneral === 'CONFORME' ? 'X' : ''}</div> CONFORME</div>
                  <div class="checkbox-item"><div class="box">${extraData?.estadoGeneral === 'INCONFORME' ? 'X' : ''}</div> INCONFORME</div>
                  <div class="checkbox-item"><div class="box">${extraData?.estadoGeneral === 'CONFORME CON OBSERVACIONES' ? 'X' : ''}</div> CONFORME CON OBSERVACIONES</div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="status-label" style="height: 120px;">OBSERVACIONES ADICIONALES</td>
              <td>
                ${extraData?.observaciones || ''}
                ${(extraData?.mantenimientoTipo || currentEquipo.mantenimiento_tipo) ? `<div style="margin-top: 10px; border-top: 1px solid #000; padding-top: 10px;"><strong>DIAGNÓSTICO TÉCNICO:</strong> ${extraData?.mantenimientoTipo || currentEquipo.mantenimiento_tipo}</div>` : ''}
                ${extraData?.evidencia ? `
                  <div style="margin-top: 15px; border-top: 1.5px solid #000; padding-top: 10px; text-align: center;">
                    <strong>EVIDENCIA FOTOGRÁFICA:</strong><br><br>
                    <img src="${extraData.evidencia}" style="max-height: 180px; border: 1px solid #000; border-radius: 4px;">
                  </div>
                ` : ''}
              </td>
            </tr>
          </table>

          <div class="conformity">
            <strong>DECLARACIÓN DE CONFORMIDAD:</strong> La parte que RECIBE, declara que:<br>
            1. Ha inspeccionado físicamente los activos detallados y verifica que corresponden a la cantidad y tipo solicitados.<br>
            2. El estado de los activos es CONFORME (salvo las observaciones específicas indicadas en la tabla anterior).<br>
            3. A partir de la fecha de la presente Acta, los activos pasan a ser responsabilidad de la Unidad/Departamento y/o funcionario que recibe para su custodia, uso e inventario. En constancia de lo anterior, se firma la presente Acta de Recepción Conforme${declarationExtra}.
          </div>

          <div class="signature-section">
            <div class="signature-box" style="position: relative; padding-top: 50px;">
              ${extraData?.signatureEncargado ? `<img src="${extraData.signatureEncargado}" style="position: absolute; bottom: 45px; left: 50%; transform: translateX(-50%); height: 85px;">` : ''}
              <div class="signature-line" style="margin-top: 40px;"></div>
              <div class="signature-name">${encargadoNombre.toUpperCase()}</div>
              <div class="signature-title">Encargado/a de Inventario Municipal</div>
            </div>
            ${type !== 'ingreso_bodega' ? `
              <div class="signature-box" style="position: relative; padding-top: 50px;">
                ${extraData?.signatureCustodio ? `<img src="${extraData.signatureCustodio}" style="position: absolute; bottom: 45px; left: 50%; transform: translateX(-50%); height: 85px;">` : ''}
                <div class="signature-line" style="margin-top: 40px;"></div>
                <div class="signature-name">${docNombre.toUpperCase()}</div>
                <div class="signature-title">${funcionarioData ? funcionarioData.cargo : 'Funcionario Responsable'}</div>
              </div>
            ` : `
              <div class="signature-box" style="position: relative; padding-top: 50px;">
                <div style="margin-top: 40px; color: #666; font-style: italic; font-size: 9pt;">REGISTRO INICIAL - SOLO FIRMA ENCARGADO</div>
              </div>
            `}
          </div>
        </div>
      `}
    </body>
    </html>
  `;
};
